/**
 * iQuicker
 * Copyright 2015
 *
 */
var ROOTSCOPE_BROADCAST = {};

(function () {
    angular.module('home', [
        'ui.router',                    // Routing
        'ui.select',
        'oc.lazyLoad',                  // ocLazyLoad
        'ui.bootstrap',                 // Ui Bootstrap
        'LocalStorageModule',			// local storage
		'iq_common',
		'angularFileUpload',
		'angulartics',
		'angulartics.baidu',
    'angulartics.growingio',
		'pascalprecht.translate',
		'ngClipboard',
    ]);

    var $body = $("body");
    $("#blueimp-gallery").on("open",function(){
    	$body.addClass("blueimp-gallery-opened");
    }).on("closeed",function(){
    	$body.removeClass("blueimp-gallery-opened");
    });
})();
